module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t3-9.94590b7a.svg";